module.exports = __webpack_public_path__ + "static/img/projectIco.ebbc6b92.svg";